export const FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES = {
  START: 'START_FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES',
  COMPLETE: 'COMPLETE_FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES',
  FAIL: 'FAIL_FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES',
  CLEANUP: 'CLEANUP_FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES',
}

export const ADD_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE =
  'ADD_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE'

export const RENAME_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE =
  'RENAME_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE'

export const SET_IS_CURATION_ENABLED_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY = {
  START: 'START_SET_IS_CURATION_ENABLED_LOCATION_TYPE',
  COMPLETE: 'COMPLETE_SET_IS_CURATION_ENABLED_LOCATION_TYPE',
  FAIL: 'FAIL_SET_IS_CURATION_ENABLED_LOCATION_TYPE',
}

export const DELETE_LOCATION_TYPE = {
  START: 'START_DELETE_LOCATION_TYPE',
  COMPLETE: 'COMPLETE_DELETE_LOCATION_TYPE',
  FAIL: 'FAIL_DELETE_LOCATION_TYPE',
}

export const DELETE_LOCATION_TYPE_CATEGORY = {
  START: 'START_DELETE_LOCATION_TYPE_CATEGORY',
  COMPLETE: 'COMPLETE_DELETE_LOCATION_TYPE_CATEGORY',
  FAIL: 'FAIL_DELETE_LOCATION_TYPE_CATEGORY',
}

export const REPLACE_LOCATION_TYPE = {
  START: 'START_REPLACE_LOCATION_TYPE',
  COMPLETE: 'COMPLETE_REPLACE_LOCATION_TYPE',
  FAIL: 'FAIL_REPLACE_LOCATION_TYPE',
}

export const REVERT_REPLACE_LOCATION_TYPE = {
  START: 'START_REVERT_REPLACE_LOCATION_TYPE',
  COMPLETE: 'COMPLETE_REVERT_REPLACE_LOCATION_TYPE',
  FAIL: 'FAIL_REVERT_REPLACE_LOCATION_TYPE',
}

export const RESET_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_TREE =
  'RESET_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_TREE'

export const SET_DATA_FOR_RENAMING_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE =
  'SET_DATA_FOR_RENAMING_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE'

export const MOVE_LOCATION_TYPES = 'MOVE_LOCATION_TYPES'

export const SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES = {
  START: 'START_SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES',
  COMPLETE: 'COMPLETE_SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES',
  FAIL: 'FAIL_SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES',
}

export const EXPAND_LOCATION_TYPE_AND_LOCATION_TYPE_CATEGORY_MAIN_TREE_KEYS =
  'EXPAND_LOCATION_TYPE_AND_LOCATION_TYPE_CATEGORY_MAIN_TREE_KEYS'

export const EXPAND_LOCATION_TYPE_AND_LOCATION_TYPE_CATEGORY_SUPPORTING_TREE_KEYS =
  'EXPAND_LOCATION_TYPE_AND_LOCATION_TYPE_CATEGORY_SUPPORTING_TREE_KEYS'
